import React, { useState } from 'react';

import styled from 'styled-components';

import { useCommunityViewWidgetModalContext } from './CommunityViewWidgetModalContext';
import WidgetGroupingCategoriesModal from '../modals/WidgetGroupingCategoriesModal/WidgetGroupingCategoriesModal';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
`;

const Advanced = styled.div`
  color: var(--dark-blue);
  cursor: pointer;
`;

const CommunityViewWidgetModalEditCategories = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { groupBy } = useCommunityViewWidgetModalContext();

  if (!groupBy) {
    return null;
  }

  return (
    <>
      <Container>
        Grouping
        <Advanced onClick={() => setModalOpen(true)}>Advanced...</Advanced>
      </Container>
      <WidgetGroupingCategoriesModal open={modalOpen} groupBy={groupBy} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default CommunityViewWidgetModalEditCategories;
